"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileLandscapeView = void 0;
var _hooks = require("../../hooks");
var _MobileLandscapeView = require("./MobileLandscapeView.labels");
var _MobileLandscapeView2 = _interopRequireDefault(require("./MobileLandscapeView.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MobileLandscapeView = function MobileLandscapeView(props) {
  var _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'AssertPortraitView' : _props$mode,
    _props$showMessage = props.showMessage,
    showMessage = _props$showMessage === void 0 ? true : _props$showMessage,
    _props$mobileWidthThr = props.mobileWidthThreshold,
    mobileWidthThreshold = _props$mobileWidthThr === void 0 ? 820 : _props$mobileWidthThr,
    _props$mobileHeightTh = props.mobileHeightThreshold,
    mobileHeightThreshold = _props$mobileHeightTh === void 0 ? 820 : _props$mobileHeightTh;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isDeviceDataReady = _useDeviceData.isDeviceDataReady,
    isMobile = _useDeviceData.isMobile,
    isLandscape = _useDeviceData.isLandscape,
    isPortrait = _useDeviceData.isPortrait,
    isTouchScreen = _useDeviceData.isTouchScreen,
    viewWidth = _useDeviceData.viewWidth,
    viewHeight = _useDeviceData.viewHeight;
  var getLabel = (0, _hooks.useLabels)({
    labels: _MobileLandscapeView.labels
  });
  var styles = (0, _MobileLandscapeView2.default)(props);
  var isMobileDevice = isMobile || isTouchScreen && (mobileWidthThreshold >= viewWidth || mobileHeightThreshold >= viewHeight);
  if (!isDeviceDataReady || !isMobileDevice || mode === 'AssertPortraitView' && isPortrait || mode === 'AssertLandscapeView' && isLandscape) {
    return null;
  }
  var message = mode === 'AssertLandscapeView' ? getLabel('assertLandscapeMessage') : getLabel('assertPortraitMessage');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": 'MobileLandscapeView',
    className: styles['cc-MobileLandscapeView'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 581 581",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            className: "path1",
            d: "M502.5,383.5L369.7,516.3c-16.8,16.8-44.1,16.8-60.9,0l-213-213c-16.8-16.8-16.8-44.1,0-60.9l132.8-132.8     c16.8-16.8,44.1-16.8,60.9,0l213,213C519.3,339.5,519.3,366.7,502.5,383.5z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ellipse", {
            className: "path3",
            cx: "374.4",
            cy: "388.3",
            rx: "21.5",
            ry: "21.5"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            className: "path1",
            d: "M406.7,76.2c71.3,0,129.1,57.8,129.1,129.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            className: "path1",
            d: "M191.5,549.7c-71.3,0-129.1-57.8-129.1-129.1"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
            className: "path2",
            points: "45.2,142.2 100.6,142.2 100.6,31.3"
          })
        })]
      })
    }), showMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-MobileLandscapeViewMessage'],
      children: message
    })]
  });
};
exports.MobileLandscapeView = MobileLandscapeView;